import { defineComponent as _defineComponent } from 'vue';
import PageTitle from "@/components/PageTitle.vue";
import Vue, { computed, shallowRef, watch } from "vue";
import DividingHeader from "@/components/DividingHeader.vue";
import Axios from "axios";
import VehicleAutocompleteWithoutFetch from "@/components/VehicleAutocompleteWithoutFetch.vue";
import JobAutocompleteInput from "@/components/Job/JobAutocompleteInput.vue";
import EmployeeAutocompleteInput from "@/components/V2/EmployeeAutocompleteInput.vue";
import PhotoThumbnail from "@/components/Photos/PhotoThumbnail.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolReport',
    setup(__props) {
        const job = shallowRef(null);
        const employee = shallowRef(null);
        const vehicle = shallowRef(null);
        const tab = shallowRef("job");
        const tools = shallowRef([]);
        const groupedTools = shallowRef([]);
        const jobs = shallowRef([]);
        const employees = shallowRef([]);
        const vehicles = shallowRef([]);
        const selected = shallowRef(null);
        const tableHeaders = [
            {
                text: '',
                value: 'photo'
            },
            {
                text: "Model Name",
                align: 'start',
                sortable: true,
                value: 'tool_model.name'
            },
            {
                text: 'Qty',
                align: 'center',
                sortable: true,
                value: 'count'
            }
        ];
        watch(tab, (tab, prevTab) => {
            job.value = null;
            employee.value = null;
            vehicle.value = null;
        });
        async function fetchData() {
            const response = await Axios.get('/v3/tools/reports/data');
            jobs.value = response.data.jobs;
            employees.value = response.data.employees;
            vehicles.value = response.data.vehicles;
        }
        fetchData();
        const title = computed(() => {
            let parts = ["Tool Report"];
            if (tab.value === "job" && job.value) {
                parts.push(`${job.value.job_number} ${job.value.description}`);
            }
            if (tab.value === "employee" && employee.value) {
                parts.push(employee.value.name);
            }
            if (tab.value === "vehicle" && vehicle.value) {
                parts.push(`${vehicle.value.make.name} ${vehicle.value.name} (${vehicle.value.driver_name})`);
            }
            return parts.join(" - ");
        });
        async function fetchReport(tab) {
            let id = null;
            if (tab === "job") {
                id = job.value?.id;
            }
            if (tab === "employee") {
                id = employee.value?.id;
            }
            if (tab === "vehicle") {
                id = vehicle.value?.id;
            }
            if (id) {
                try {
                    const response = await Axios.get(`/v3/tools/reports/${tab}/${id}`);
                    groupedTools.value = response.data.grouped_tools;
                    tools.value = response.data.tools;
                    Vue.$toast.success('Report fetched successfully.');
                }
                catch (error) {
                    console.error(error);
                    error('Error fetching report data. Please try again later.');
                }
            }
            else {
                tools.value = [];
            }
        }
        return { __sfc: true, job, employee, vehicle, tab, tools, groupedTools, jobs, employees, vehicles, selected, tableHeaders, fetchData, title, fetchReport, PageTitle, DividingHeader, VehicleAutocompleteWithoutFetch, JobAutocompleteInput, EmployeeAutocompleteInput, PhotoThumbnail };
    }
});
